// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"252":"fc384be584820cbceadb","634":"f0ef5a6cd97f97d491bd"}[chunkId] + ".js";
};